/**
 * Utility functions for locale-based navigation
 */

import { SUPPORTED_LOCALES } from '@/lib/constants';

/**
 * Strips the locale prefix from a pathname and constructs a new path with the target locale
 * @param pathname - Current pathname
 * @param newLocale - Target locale to switch to
 * @returns New path with the target locale
 */
export function constructLocaleNavigationPath(pathname: string, newLocale: string): string {
  // Strip the locale prefix from the current path
  let pathWithoutLocale = pathname || '/';

  // Only remove locale from the first segment (not from deeper path segments)
  const segments = pathWithoutLocale.split('/').filter(Boolean);
  if (segments.length > 0 && SUPPORTED_LOCALES.includes(segments[0] as any)) {
    segments.shift();
  }
  pathWithoutLocale = segments.length > 0 ? `/${segments.join('/')}` : '/';

  // Construct the new path with the selected locale
  const newPath = `/${newLocale}${pathWithoutLocale === '/' ? '' : pathWithoutLocale}`;

  return newPath;
}

/**
 * Navigates to a new locale using full page reload
 * @param pathname - Current pathname
 * @param newLocale - Target locale to switch to
 */
export function navigateToLocale(pathname: string, newLocale: string): void {
  const newPath = constructLocaleNavigationPath(pathname, newLocale);
  // Use window.location.href for a full page reload to update translations immediately
  window.location.href = newPath;
}
